import { render } from "./RegisterTypeClassificationSelector.vue?vue&type=template&id=6b9b7c14"
import script from "./RegisterTypeClassificationSelector.vue?vue&type=script&lang=js"
export * from "./RegisterTypeClassificationSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__